// import { useEffect } from 'react';
import { IonBackButton, IonButton, IonButtons,  IonIcon, IonInput, IonItem, IonLabel } from '@ionic/react';
import { chevronBack, mail } from 'ionicons/icons';

// import { AppContext } from '../Services/State';

const otp: React.FC<any> = ({username, routerFunction, onsubmit}) => {
  if (username === "") {
    username = localStorage.getItem("username");
  } 
  
  return (
    <>
    <div className="topDiv">
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
      <IonButtons slot="start" className="myHead">
          <IonBackButton className="mtBackBtn" defaultHref="home" text="Back" icon={chevronBack} />
      </IonButtons>
      <div className='logContainer'>
        <div className='logo'><img alt='logo' src='assets/icon/logo.png'/></div>
        <h1>One time pin</h1>

        <form method="POST" onSubmit={onsubmit}>
          <input type="hidden" name="type" defaultValue="otp" />
          <input type="hidden" name="username" defaultValue={username} />
          <IonItem className="ionMyItem">
            <IonLabel position="floating" className="theLabel" >OTP</IonLabel>
            <IonIcon className="iconPart" icon={mail} />
            <IonInput name="otp" type="text" className="theInput" required />
          </IonItem>
          <br/>
          <br/>
          <IonButton expand="block" type="submit" className="ion-activatable ripple-parent">Submit</IonButton>
        </form>
        <br/>
        <br/>
        <div className="myButtons">                                            
          <p className="myForgot" onClick={()=>routerFunction('register')}>Remember your password?  <span>Sign in</span></p>          
        </div>
      </div>
    </div>
  </>
  );
};

export default otp;
